{
  "webAppUrl": {
    "production": "https://html.plugin.tomake.design",
    "preview": "https://preview.html-to-figma.pages.dev",
    "development": "http://localhost:5173"
  },
  "apiBaseUrl": {
    "production": "https://html.plugin.tomake.design/api",
    "development": "https://preview.html-to-figma.pages.dev/api",
    "local": "http://localhost:8788/api"
  },
  "apiEnvironment": "production",
  "turnstileSiteKey": "",
  "window": {
    "width": 480,
    "height": 640
  },
  "limits": {
    "batchUrls": 20,
    "traversalNodes": 20000
  },
  "timeouts": {
    "handshakeMs": 10000
  }
}
